import { EMPTY_STRING } from "../../../constants";
import CustomTooltip from "../toolTipComponent/CustomTooltip";
import TitleToolTip from "../toolTipComponent/TitleToolTip";

const TableCustomHeader = ({
  id,
  label,
  tooltopText,
  titleToolTipText,
  className = EMPTY_STRING,
}) => {
  const LabelComponent = () => (
    <div className="text-truncate w-auto" id={id}>
      {label}
    </div>
  );

  return (
    <>
      {tooltopText ? (
        <>
          <CustomTooltip
            className={`tooltip-for-text ${className}`}
            anchorSelect={`#${id}`}
          >
            {tooltopText}
          </CustomTooltip>
          <LabelComponent />
        </>
      ) : titleToolTipText ? (
        <TitleToolTip title={titleToolTipText} children={label} />
      ) : label ? (
        <LabelComponent />
      ) : (
        EMPTY_STRING
      )}
    </>
  );
};

export default TableCustomHeader;
